import { render } from "./ProfileInputFields.vue?vue&type=template&id=9f195c8e&scoped=true&ts=true"
import script from "./ProfileInputFields.vue?vue&type=script&lang=ts"
export * from "./ProfileInputFields.vue?vue&type=script&lang=ts"

import "./ProfileInputFields.vue?vue&type=style&index=0&id=9f195c8e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f195c8e"]])

export default __exports__